import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import '../../rxjs-extensions';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { MomentModule } from 'angular2-moment';

import { AppComponent } from './app.component';

import { FeedComponent } from './feeds/feed/feed.component';
import { FeedListComponent } from './feeds/feed-list/feed-list.component';
import { FeedDetailComponent } from './feeds/feed-detail/feed-detail.component';
import { FeedDownloadLinkComponent } from './feeds/feed-download-link/feed-download-link.component';

import { FeedManager } from './feeds/shared/feed-manager.service';

import { FeedService } from './feeds/shared/feed.service';
import { FeedServiceImpl } from './feeds/shared/feed-impl.service';
import { FeedMetadataService } from './feeds/shared/feed-metadata.service';
import { FeedMetadataServiceImpl } from './feeds/shared/feed-metadata-impl.service';
import { FeedColumnLookupService } from './feeds/shared/feed-column-lookup.service';
import { FeedColumnLookupServiceImpl } from './feeds/shared/feed-column-lookup-impl.service';
import { FeedSelectorConfigurationService } from './feeds/shared/feed-selector-configuration.service';

import { HttpUtilityService } from './../shared/http-utility.service';
import { HttpUtilityServiceImpl } from './../shared/http-utility-impl.service';
import { ConfigurationService } from './../shared/configuration.service';
import { ConfigurationServiceImpl } from './../shared/configuration-impl.service';
import { RouteLoggerService } from './../shared/route-logger.service';
import { RouteLoggerServiceImpl } from './../shared/route-logger-impl.service';
import { EventLoggerService } from './../shared/event-logger.service';
import { EventLoggerServiceImpl } from './../shared/event-logger-impl.service';
import { ErrorManagerService } from './../shared/error-handling/error-manager.service';
import { ErrorManagerServiceImpl } from './../shared/error-handling/error-manager-impl.service';
import { WindowService } from './../shared/window.service';
import { NotificationService } from './../shared/notification.service';
import { HeaderMenuService } from './../shared/header-menu.service';
import { FeedbackService } from './../shared/feedback.service';
import { FeedbackServiceImpl } from './../shared/feedback-impl.service';
import { CookieService } from './../shared/cookie.service';

import { AppRoutingModule } from './app-routing.module';
import { ErrorComponent } from './../shared/error-handling/error.component';
import { NotFoundComponent } from './../shared/error-handling/not-found/not-found.component';
import { GeneralErrorComponent } from './../shared/error-handling/general-error/general-error.component';
import { FeedTreeNavComponent } from './feeds/feed-tree-nav/feed-tree-nav.component';
import { CollapseDirective } from './../shared/widgets/collapse.directive';
import { FrequentlyAccessedComponent } from './feeds/frequently-accessed/frequently-accessed.component';
import { FeedGridHeaderComponent } from './feeds/feed-grid-header/feed-grid-header.component';
import { FeedGridComponent } from './feeds/feed-grid/feed-grid.component';
import { FeedGridRowComponent } from './feeds/feed-grid-row/feed-grid-row.component';
import { FeedGridPagerComponent } from './feeds/feed-grid-pager/feed-grid-pager.component';
import { HeaderComponent } from './../shared/header/header.component';
import { FooterComponent } from './../shared/footer/footer.component';
import { DatepickerComponent } from './../shared/datepicker/datepicker.component';
import { DatepickerListComponent } from './../shared/datepicker-list/datepicker-list.component';
import { FeedApiInstructionsComponent } from './feeds/feed-api-instructions/feed-api-instructions.component';
import { FeedMainComponent } from './feeds/feed-main/feed-main.component';
import { SearchBoxComponent } from './../shared/search-box/search-box.component';
import { MetadataSearchResultsComponent } from './feeds/metadata-search-results/metadata-search-results.component';
import { NotificationBarComponent } from './../shared/notification-bar/notification-bar.component';
import { HeaderMenuComponent } from './../shared/header-menu/header-menu.component';
import { HeaderMenuItemComponent } from './../shared/header-menu-item/header-menu-item.component';
import { HeaderMenuSubItemComponent } from './../shared/header-menu-sub-item/header-menu-sub-item.component';
import { TimepickerComponent } from './../shared/timepicker/timepicker.component';
import { FeedbackComponent } from './../shared/feedback/feedback.component';
import { OrderByPipe } from './../shared/widgets/orderby.pipe';
import { FeedGridSelectorComponent } from './feeds/feed-grid-selector/feed-grid-selector.component';
import { FeedRepostComponent } from './feeds/feed-repost/feed-repost.component';
import { FeedRssComponent } from './feeds/feed-rss/feed-rss.component';
import { Globals } from '../../config/globals';

const appInitializer = (appConfig: Globals) => {
    return () => {
      return appConfig.loadAppConfig();
    };
  };

@NgModule({
    declarations: [
        AppComponent,
        FeedComponent,
        FeedListComponent,
        FeedDetailComponent,
        FeedDownloadLinkComponent,
        ErrorComponent,
        NotFoundComponent,
        GeneralErrorComponent,
        FeedTreeNavComponent,
        CollapseDirective,
        FrequentlyAccessedComponent,
        FeedGridHeaderComponent,
        FeedGridComponent,
        FeedGridRowComponent,
        FeedGridPagerComponent,
        HeaderComponent,
        FooterComponent,
        DatepickerComponent,
        DatepickerListComponent,
        FeedApiInstructionsComponent,
        FeedMainComponent,
        SearchBoxComponent,
        MetadataSearchResultsComponent,
        NotificationBarComponent,
        HeaderMenuComponent,
        HeaderMenuItemComponent,
        HeaderMenuSubItemComponent,
        FeedbackComponent,
        TimepickerComponent,
        OrderByPipe,
        FeedGridSelectorComponent,
        FeedRssComponent,
        FeedRepostComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        AppRoutingModule,
        Ng2DatetimePickerModule,
        MomentModule
    ],
    providers: [
        Globals,
        {provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [Globals]},
        Title,
        FeedManager,
        WindowService,
        CookieService,
        NotificationService,
        HeaderMenuService,
        FeedSelectorConfigurationService,
        { provide: FeedService, useClass: FeedServiceImpl },
        { provide: FeedMetadataService, useClass: FeedMetadataServiceImpl },
        { provide: FeedColumnLookupService, useClass: FeedColumnLookupServiceImpl },
        { provide: HttpUtilityService, useClass: HttpUtilityServiceImpl },
        { provide: RouteLoggerService, useClass: RouteLoggerServiceImpl },
        { provide: EventLoggerService, useClass: EventLoggerServiceImpl },
        { provide: ConfigurationService, useClass: ConfigurationServiceImpl },
        { provide: ErrorManagerService, useClass: ErrorManagerServiceImpl },
        { provide: FeedbackService, useClass: FeedbackServiceImpl }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/main/app.module.ts